/* @flow */

export default class Country {
  id: number;
  name: string;
  code: string;
}
